module.exports = __webpack_public_path__ + "img/map-zoom.904fb970.png";